<template>
  <div class="sms-style-config" style="width: 580px;">
    <a-tabs v-model:activeKey="initState.tabType">
      <!-- 步骤1: Email表单配置 -->
      <a-tab-pane :key="20" tab="Email"> </a-tab-pane>
      <!-- 步骤2: SMS表单配置 -->
      <a-tab-pane :key="21" tab="SMS"> </a-tab-pane>
      <a-tab-pane :key="22" tab="Email + SMS"> </a-tab-pane>
    </a-tabs>
    <a-form :model="langState" :rules="rules" ref="formRef" layout="vertical">
      <a-collapse
        v-model:activeKey="activeKey"
        :bordered="false"
        style="background: #fff"
      >
        <!-- 弹窗表单配置 -->
        <a-collapse-panel
          key="1"
          header="弹窗表单配置"
          v-if="[20, 21].includes(initState.tabType)"
        >
          <a-form-item required label="标题" name="title">
            <a-input
              v-model:value="langState.title"
              placeholder="请输入标题"
              :maxlength="50"
              show-count
            />
          </a-form-item>
          <a-form-item label="主文案" name="mainText" required>
            <a-textarea
              v-model:value="langState.mainText"
              placeholder="请输入描述"
              :maxlength="200"
              show-count
              :rows="3"
            />
          </a-form-item>
          <a-form-item required label="描述" name="descriptionText">
            <a-textarea
              v-model:value="langState.descriptionText"
              placeholder="请输入描述"
              :maxlength="200"
              show-count
              :rows="3"
            />
          </a-form-item>
          <a-form-item label="输入框占位符" name="inputPlaceholder">
            <a-input
              v-model:value="langState.inputPlaceholder"
              placeholder="请输入输入框占位符"
              :maxlength="20"
              show-count
            />
          </a-form-item>
          <a-form-item label="按钮文案" name="buttonText" required>
            <a-input
              v-model:value="langState.buttonText"
              placeholder="请输入按钮文案"
              :maxlength="20"
              show-count
            />
          </a-form-item>
          <a-form-item label="条款文案" name="termsText" required>
            <QuillTextarea
              :isQuillEditor="true"
              v-model:value="langState.termsText"
              :terminal-id="initState?.queryParams?.terminalId"
              scroll-into-view-class="checkTab"
              style="height: 100px;"
            />
          </a-form-item>
        </a-collapse-panel>
        <!-- 成功反馈配置 -->
        <a-collapse-panel
          key="2"
          :header="successHeaderText"
          class="successHeader"
        >
          <a-form-item label="成功标题" name="successTitle" required>
            <a-input
              v-model:value="langState.successTitle"
              placeholder="请输入标题"
              :maxlength="50"
              show-count
            />
          </a-form-item>
          <a-form-item label="成功描述" name="successDescription">
            <a-textarea
              v-model:value="langState.successDescription"
              placeholder="请输入描述"
              :maxlength="200"
              show-count
              :rows="3"
            />
          </a-form-item>
          <a-form-item label="按钮文案" name="successButtonText" required>
            <a-input
              v-model:value="langState.successButtonText"
              placeholder="请输入按钮文案"
              :maxlength="20"
              show-count
            />
          </a-form-item>
          <a-form-item label="按钮跳转链接" name="successButtonLink">
            <a-input
              v-model:value="langState.successButtonLink"
              placeholder="请输入有效的链接地址"
            />
          </a-form-item>
          <div
            class="bg-upload-container"
            v-if="[21].includes(initState.tabType)"
          >
            <a-form-item label="SMS悬浮图 (不超过2MB，建议 130x80)">
              <ImageMaterialUpload
                v-model:fileList="formState.mSmsSuspendImgUrl"
                v-model:materialId="formState.materialSmsSuspendIdMImg"
                v-model:materialSource="formState.materialSmsSuspendMImg"
                :validate-area="['130*80']"
                :site-id="initState?.queryParams?.siteId"
                :terminal-id="initState?.queryParams?.terminalId"
                :sub-terminal-id="2"
              />
            </a-form-item>
          </div>
        </a-collapse-panel>

        <!-- 背景图配置 -->
        <a-collapse-panel
          key="3"
          :header="bgConfigHeader"
          v-if="[20].includes(initState.tabType)"
        >
          <div class="bg-upload-container">
            <a-form-item
              v-if="!isAppTerminal"
              label="PC背景图 (不超过2MB，建议 420x560)"
            >
              <ImageMaterialUpload
                v-model:fileList="formState.pcImgUrl"
                :validate-area="['420*560']"
                :site-id="initState?.queryParams?.siteId"
                :terminal-id="initState?.queryParams?.terminalId"
                :sub-terminal-id="initState?.queryParams?.terminalId"
              />
            </a-form-item>
            <a-form-item :label="mobileOrAppBgLabel">
              <ImageMaterialUpload
                v-model:fileList="formState.mImgUrl"
                :validate-area="['375*600']"
                :site-id="initState?.queryParams?.siteId"
                :terminal-id="initState?.queryParams?.terminalId"
                :sub-terminal-id="2"
              />
            </a-form-item>
          </div>
          <div class="bg-upload-container">
            <a-form-item label="Email悬浮图 (不超过2MB，建议 130x80)">
              <ImageMaterialUpload
                v-model:fileList="formState.mEmailSuspendImgUrl"
                v-model:materialId="formState.materialEmailSuspendIdMImg"
                v-model:materialSource="formState.materialEmailSuspendMImg"
                :validate-area="['130*80']"
                :site-id="initState?.queryParams?.siteId"
                :terminal-id="initState?.queryParams?.terminalId"
                :sub-terminal-id="2"
              />
            </a-form-item>
          </div>
        </a-collapse-panel>
      </a-collapse>
    </a-form>
  </div>
</template>

<script setup>
import { computed, inject, ref, defineExpose } from 'vue'
import QuillTextarea from './quill-textarea.vue'
import ImageMaterialUpload from './image-material-upload.vue'
const initState = inject('initState')
const formRef = ref()
const activeKey = ref(['1', '2', '3'])
const isAppTerminal = computed(
  () => String(initState?.queryParams?.terminalId) === '2'
)

const bgConfigHeader = computed(() =>
  isAppTerminal.value ? '背景图配置 (APP)' : '背景图配置 (PC & M)'
)

const mobileOrAppBgLabel = computed(() =>
  isAppTerminal.value
    ? 'APP背景图 (不超过2MB，建议 375x600)'
    : 'M端背景图 (不超过2MB，建议 375x600)'
)

const pepopleTabMapKey = computed(() => initState.pepopleTabMapKey)

const formState = computed(() => {
  return pepopleTabMapKey.value
    ? initState.pepopleTabMap?.[pepopleTabMapKey.value]
    : {}
})

const langState = computed(() => formState.value?.[initState.langCode] || {})

const rules = {
  title: [
    { required: true, message: '请输入标题', trigger: 'blur' },
    { min: 1, max: 50, message: '1-50字符', trigger: 'blur' }
  ],
  mainText: [
    { required: true, message: '请输入主文案', trigger: 'blur' },
    { min: 1, max: 200, message: '1-200字符', trigger: 'blur' }
  ],
  descriptionText: [
    { required: true, message: '请输入描述', trigger: 'blur' },
    { min: 1, max: 200, message: '1-200字符', trigger: 'blur' }
  ],
  inputPlaceholder: [
    { required: false, message: '请输入输入框占位符', trigger: 'blur' },
    { min: 1, max: 20, message: '1-20字符', trigger: 'blur' }
  ],
  buttonText: [
    { required: true, message: '请输入按钮文案', trigger: 'blur' },
    { min: 1, max: 20, message: '1-20字符', trigger: 'blur' }
  ],
  termsText: [
    // { required: true, message: '条款必须包含隐私政策链接', trigger: 'blur' },
    {
      validator: (rule, value) => {
        if (!value) return Promise.reject('请输入条款内容')
        // 简单校验包含 href
        if (
          value.indexOf('href=') === -1 &&
          +initState?.queryParams?.terminalId === 1
        ) {
          return Promise.reject('条款必须包含隐私政策链接')
        }
        return Promise.resolve()
      },
      trigger: 'blur'
    }
  ],
  successButtonLink: [
    { required: false, message: '请输入有效的链接地址', trigger: 'blur' },
    {
      validator: (rule, value) => {
        if (!value) return Promise.resolve()
        // 校验是否是合法URL或相对路径
        const urlPattern = /^(https?:\/\/|cupshe:\/\/|\/)/i
        if (!urlPattern.test(value)) {
          return Promise.reject('必须是合法URL或相对路径')
        }
        return Promise.resolve()
      },
      trigger: 'blur'
    }
  ]
}

const successHeaderText = computed(() => {
  if (+initState.tabType === 20) {
    return '仅Email订阅成功配置'
  }
  if (+initState.tabType === 21) {
    return '仅SMS订阅成功配置'
  }
  if (+initState.tabType === 22) {
    return '全部订阅成功配置'
  }
  return '订阅成功配置'
})

defineExpose({
  validate: () => {
    if (!formRef.value) return Promise.resolve(true)
    return formRef.value.validate()
  }
})
</script>

<style scoped>
.bg-upload-container {
  display: flex;
  gap: 40px;
}
:deep(.ant-collapse-item) {
  border: 1px solid #d9d9d9;
  border-radius: 8px !important;
  margin-bottom: 16px;
  /* overflow: hidden; */
}
:deep(.ant-collapse-header) {
  background-color: #f5f7fa;
}
:deep(.successHeader .ant-collapse-header) {
  background-color: #f0fdf4;
}
</style>
